import { Injectable } from '@angular/core';
import { ApiService, PagedSearch, PagedResult, PagedResultGeneric } from '../../shared/index';
import { RelationType } from './relation-type-model';
import { RelationTypeSearchResults } from './relation-type-search-result.model';
import { RelationTypeSearchParams } from './relation-type-search-params.model';

@Injectable()
export class RelationTypeService {
  public _apiService: ApiService;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public create(dto: RelationType): Promise<void> {
    return this._apiService.post('RelationTypes', dto);
  }

  public update(dto: RelationType): Promise<void> {
    return this._apiService.put(`RelationType/${dto.RelationTypeId}`, dto);
  }

  public delete(id: number): Promise<void> {
    return this._apiService.delete(`RelationType/${id}`);
  }

  public search = (params: RelationTypeSearchParams, forceRefresh?: boolean): Promise<PagedResultGeneric<RelationType>> => {
    let url: string = '/RelationTypes';
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : null;
    return this._apiService.getPaged(url, params, cacheOptions);
  };

  public getRelationshipType = (id: number): Promise<RelationType> => {
    let url: string = '/RelationType/' + id;
    return this._apiService.get(url);
  };
}
